import React from 'react';
import StepPlaceholder from './StepPlaceholder';

const PricingPage = () => <StepPlaceholder stepKey="pricing" />;

export default PricingPage;
